import type { FC } from "react"

import { InventoryQuantityDifference } from "../../../../components"
import type { InventoryLotWithPallet } from "../../../../types"
import { createAdjustmentNewQuantitySchema } from "../../schemas"
import { AdjustmentLotDeleteNotice } from "../AdjustmentLotDeleteNotice"
import { AdjustmentSelectedLots } from "../AdjustmentSelectedLots"

interface QuantityAdjustmentFormLotsProps {
  selectedLots: InventoryLotWithPallet[]
  uomName: string
  quantityByLotId: Record<string, number | null>
  onQuantityChange: (lotId: string, value: number | null) => void
  onLotRemove: (lotId: string) => void
}

export const QuantityAdjustmentFormLots: FC<QuantityAdjustmentFormLotsProps> = ({
  selectedLots,
  uomName,
  quantityByLotId,
  onQuantityChange,
  onLotRemove,
}) => {
  return (
    <AdjustmentSelectedLots
      selectedLots={selectedLots}
      uomName={uomName}
      testIdPrefix='inventory.quantity-adjustment-form-lots'
      title='Specify Quantities'
      emptyState={{
        title: "No lots selected",
        description: "Select lot(s) from the table above using the checkboxes to adjust quantities.",
      }}
      inputColumn={{
        header: "New UoM Qty",
        values: quantityByLotId,
        createSchema: createAdjustmentNewQuantitySchema,
        renderHelperText: (inputQuantity) => (inputQuantity === 0 ? <AdjustmentLotDeleteNotice /> : null),
        onChange: onQuantityChange,
      }}
      derivedColumn={{
        header: "Adjustment Qty",
        render: (inputQuantity, lotQuantity, uomName) => (
          <InventoryQuantityDifference quantity={inputQuantity} originalQuantity={lotQuantity} uomName={uomName} />
        ),
      }}
      onLotRemove={onLotRemove}
    />
  )
}
